import React, { useEffect } from 'react'
import Loading from '../../components/Loading'
import { Box } from '@mui/material'
import { colors, routes, token_keys } from '../../constants'
import { useNavigate } from 'react-router-dom'
import {refreshAccessToken} from "../../api/axiosInstance";

export default function LandingPage({ setAuthenticated }) {
  const navigate = useNavigate()

  const getSession = async () => {
    const token = localStorage.getItem(token_keys.refresh_token)
    if (!token) {
      navigate(routes.login)
    }
    const response = await refreshAccessToken()
    if (response.status === 200) {
      setAuthenticated(true)
      navigate(routes.surveys)
    }
  }

  useEffect(() => {
    getSession()
  }, [])

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          height: '100vh',
          width: '100vw'
        }}>
        <Box
          sx={{
            fontSize: 50,
            color: colors.main,
            my: 3,
            px: 3
          }}>
          Prompta.ai
        </Box>
        <Loading />
      </Box>
    </>
  )
}
